export const PHONE_CHANGE_ATTEMPTS_REACHED_MESSAGE =
  'You can only change your phone number three times per day. <br/>For assistance, please start a chat (click the green button in the lower right corner) or <a href="/support-request" target="_blank">create a Support Ticket</a>.';

export const VALIDATION_FAILED_MESSAGE =
  'Validation failed. Please check that you entered the code correctly and/or that your phone number is correct.';

export const PHONE_CODE_EXPIRED_MESSAGE =
  'The verification code has expired. Please click Send Code to request a new one.';

export const getPhoneAlreadyInUseMessage = (ownerEmail: string): string =>
  `The phone number you are attempting to validate has already been validated for the account with email address ${ownerEmail} and may not be used for this validation. For assistance, please start a chat (click the green button in the lower right corner) or <a href="/support-request" target="_blank">create a Support Ticket</a>.`;
